// extracted by mini-css-extract-plugin
export default {"weapon_title":"CardWeapon_weapon_title__hXXsa","card_weapon":"CardWeapon_card_weapon__v7duP","weapons":"CardWeapon_weapons__zjk8Q"};